import LegalLinks from "layout/LegalLinks";

/**
 * Legal links and Spotify's required attribution.
 *
 * These used to sit at the bottom of a 156px sidebar, where the attribution
 * had 128px to work with and wrapped roughly every three words. Across the
 * full width it reads as one or two lines.
 *
 * From sm only. Phones get MobileLegalLinks at the end of the page content
 * instead, since a fixed footer cost 37px on every screen, and the attribution
 * is hidden there by request.
 */
export function AppFooter(): JSX.Element {
  return (
    <footer className="flex-none hidden sm:flex flex-row items-center gap-x-6 gap-y-2 px-4 py-2.5 bg-surface border-t border-rule text-xs">
      <div className="flex items-center gap-4 flex-none">
        <LegalLinks />
      </div>

      <p className="text-muted leading-snug m-0">
        Music data, artist images, album covers, and song previews are provided
        by Spotify. Spotify is a trademark of Spotify AB.
      </p>
    </footer>
  );
}

export default AppFooter;
